<template>
  <component
    :is="to ? 'router-link' : 'div'"
    :to="to ? to : null"
    class="c-button"
    :class="{
      'c-button--primary': isPrimary,
      'c-button--secondary': isSecondary,
      'c-button--dangerous': isDangerous,
      'c-button--floating': isFloating,
      'c-button--floating-secondary': isFloating && isSecondary,
      'c-button--small': size === 'small'
    }"
    @click="$emit('click')"
  >
    {{ label }}
  </component>
</template>

<script>
// @group Base Components
export default {
  name: 'OButton',
  props: {
    to: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    isPrimary: {
      type: Boolean,
      default: false
    },
    isDangerous: {
      type: Boolean,
      default: false
    },
    isFloating: {
      type: Boolean,
      default: null
    },
    isSecondary: {
      type: Boolean,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss">
.c-button {
  background: none;
  border: 0.1rem solid $primary-color;
  border: 0.1rem solid var(--primary-color);
  border-radius: 2.4rem;
  color: $primary-color;
  color: var(--primary-color);
  cursor: pointer;
  display: block;
  font-size: 1.6rem;
  font-weight: 600;
  padding: 1.6rem 1.6rem;
  text-align: center;

  & + & {
    margin-top: 1.6rem;
  }
}

.c-button--small {
  padding: 0.8rem 1.2rem;
}

.c-button--primary {
  background: $primary-color;
  background: var(--primary-color);
  color: #fff !important;
}

.c-button--secondary {
  background: $background-color;
  border-color: rgba(#000, 0.1);
  color: $gray-700;
}

.c-button--floating {
  background: rgba(#fff, 0.95);
  bottom: 0.8rem;
  left: 0.8rem;
  position: absolute;
  right: 0.8rem;
}

.c-button--dangerous {
  background: none;
  border-color: $red;
  color: $red !important;
}

.c-button--floating-secondary {
  background: $background-color;
  border-color: rgba(#000, 0.1);
  bottom: 6.4rem;
  color: $gray-700;
}

.c-button--floating.c-button--primary {
  background: rgba($primary-color, 0.95);
  background: var(--primary-color-overlay);
  box-shadow: 0 3.2rem 4rem 1.6rem rgba(#fff, 0.8);
}
</style>
